import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const decodeMessage = async (payload) => {
  const { data } = await axios.post(`${API}/decode`, payload, {
    timeout: 60000,
  });
  return data;
};

export const fetchFups = async (params = {}) => {
  const { data } = await axios.get(`${API}/fups`, { params });
  return data;
};

export const fetchDecodeStats = async () => {
  const { data } = await axios.get(`${API}/decode/stats`);
  return data;
};
